import Animation = Phaser.Animations.Animation;
import {ControlType, HeroLook, Player} from "@/store/player/types";
import {Gender} from "@/model/gender";
import {Keys} from "@/constants/key";
import AnimationUtils from "@/utils/animation-utils";
import {Scene} from "phaser";
import Sprite = Phaser.GameObjects.Sprite;
import PlayerUtils from "@/utils/player-utils";

export default class Knight {

    private static readonly DEFAULT_WALKING_FRAMERATE: number = 36;

    private static manHorseIdle: Animation | undefined | boolean;
    private static manHorseWalk: Animation | undefined | boolean;

    private static womanHorseIdle: Animation | undefined | boolean;
    private static womanHorseWalk: Animation | undefined | boolean;

    /* ========================================= */

    private static manFrontIdle: Animation | undefined | boolean;
    private static manFrontWalk: Animation | undefined | boolean;
    private static manBackIdle: Animation | undefined | boolean;
    private static manBackWalk: Animation | undefined | boolean;

    private static womanFrontIdle: Animation | undefined | boolean;
    private static womanFrontWalk: Animation | undefined | boolean;
    private static womanBackIdle: Animation | undefined | boolean;
    private static womanBackWalk: Animation | undefined | boolean;

    private static acolyteIdle: Animation | undefined | boolean;
    private static acolyteWalk: Animation | undefined | boolean;

    /* ========================================= */
    /* ========================================= */
    /* ========================================= */

    private static heroLook: HeroLook;
    private static gender: Gender;

    public static createAnims(scene: Scene, player: Player, frameRateRatio: number) {
        Knight.doCreateAnims(scene, player.heroLook, player.controlType, PlayerUtils.getGender(player), frameRateRatio);
    }

    private static doCreateAnims(scene: Scene, heroLook: HeroLook, controlType: ControlType, gender: Gender, frameRateRatio: number) {

        if (heroLook === HeroLook.ACOLYTE) {
            Knight.heroLook = HeroLook.ACOLYTE;
        } else if (heroLook === HeroLook.HERO || controlType === ControlType.BW_FW) {
            Knight.heroLook = HeroLook.HERO;
        } else {
            Knight.heroLook = HeroLook.HORSE;
        }
        Knight.gender = gender;

        if (Knight.heroLook === HeroLook.ACOLYTE) {
            if (!Knight.acolyteIdle) Knight.acolyteIdle = AnimationUtils.createAnimation(scene, 'acolyte_front_idle');
            if (!Knight.acolyteWalk) Knight.acolyteWalk = AnimationUtils.createAnimation(scene, 'acolyte_front_walk', frameRateRatio);
            return;
        }

        switch (gender) {
            case Gender.female:
                if (Knight.heroLook == HeroLook.HERO) {
                    if (!Knight.womanFrontIdle) {
                        Knight.womanFrontIdle = AnimationUtils.createAnimation(scene, 'woman_front_idle');
                    }
                    if (!Knight.womanFrontWalk) {
                        Knight.womanFrontWalk = AnimationUtils.createAnimation(scene, 'woman_front_walk', frameRateRatio);
                    }

                    if (controlType == ControlType.BW_FW) {
                        if (!Knight.womanBackWalk) {
                            Knight.womanBackWalk = AnimationUtils.createAnimation(scene, 'woman_back_walk', frameRateRatio);
                        }
                        if (!Knight.womanBackIdle) {
                            Knight.womanBackIdle = AnimationUtils.createAnimation(scene, 'woman_back_idle');
                        }
                    }

                } else {
                    if (!Knight.womanHorseIdle) {
                        Knight.womanHorseIdle = AnimationUtils.createAnimation(scene, Keys.ANIM_KNIGHT_IDLE_W);
                    }
                    if (!Knight.womanHorseWalk) {
                        Knight.womanHorseWalk = AnimationUtils.createAnimation(scene, Keys.ANIM_KNIGHT_WALK_W, frameRateRatio);
                    }
                }
                break;
            default:
                if (Knight.heroLook == HeroLook.HERO) {
                    if (!Knight.manFrontIdle) {
                        Knight.manFrontIdle = AnimationUtils.createAnimation(scene, 'man_front_idle');
                    }
                    if (!Knight.manFrontWalk) {
                        Knight.manFrontWalk = AnimationUtils.createAnimation(scene, 'man_front_walk', frameRateRatio);
                    }

                    if (controlType == ControlType.BW_FW) {
                        if (!Knight.manBackIdle) {
                            Knight.manBackIdle = AnimationUtils.createAnimation(scene, 'man_back_idle');
                        }
                        if (!Knight.manBackWalk) {
                            Knight.manBackWalk = AnimationUtils.createAnimation(scene, 'man_back_walk', frameRateRatio);
                        }
                    }

                } else {
                    if (!Knight.manHorseIdle) {
                        Knight.manHorseIdle = AnimationUtils.createAnimation(scene, Keys.ANIM_KNIGHT_IDLE_M);
                    }
                    if (!Knight.manHorseWalk) {
                        Knight.manHorseWalk = AnimationUtils.createAnimation(scene, Keys.ANIM_KNIGHT_WALK_M, frameRateRatio);
                    }
                }
        }
    }

    public static isWalking(knight: Sprite) {
        return knight.anims.isPlaying && knight.anims.currentAnim!.key.includes('walk'); // FIXME
    }

    public static play(knight: Sprite, walk: boolean, fw: boolean) {
        let key;
        if (walk) {
            key = Knight.getKinghtWalk(fw);
        } else {
            key = Knight.getKinghtIdle(fw);
        }

        if (!(knight.anims.currentAnim) || knight.anims.currentAnim.key !== key) {
            knight.play(key);
        }
    }

    public static setWalkFrameRateRatio(frameRateRatio: number) {
        let rate = Knight.DEFAULT_WALKING_FRAMERATE * frameRateRatio;
        switch (Knight.gender) {
            case Gender.female:
                if (Knight.heroLook == HeroLook.HERO) {

                    if (!!Knight.womanBackWalk) {
                        // @ts-ignore
                        Knight.womanBackWalk.frameRate = rate;
                    }
                    if (!!Knight.womanFrontWalk) {
                        // @ts-ignore
                        Knight.womanFrontWalk.frameRate = rate;
                    }

                } else {
                    if (!!Knight.womanHorseWalk) {
                        // @ts-ignore
                        Knight.womanHorseWalk.frameRate = rate;
                    }
                }
                break;
            default:
                if (Knight.heroLook == HeroLook.HERO) {

                    if (!!Knight.manBackWalk) {
                        // @ts-ignore
                        Knight.manBackWalk.frameRate = rate;
                    }
                    if (!!Knight.manFrontWalk) {
                        // @ts-ignore
                        Knight.manFrontWalk.frameRate = rate;
                    }

                } else {
                    if (!!Knight.manHorseWalk) {
                        // @ts-ignore
                        Knight.manHorseWalk.frameRate = rate;
                    }
                }
        }
    }


    public static getKinghtIdle(fw: boolean): string {
        switch (Knight.heroLook) {
            case HeroLook.HORSE:
                switch (Knight.gender) {
                    case Gender.male:
                        return Keys.ANIM_KNIGHT_IDLE_M;
                    case Gender.female:
                        return Keys.ANIM_KNIGHT_IDLE_W;
                }
                return Keys.ANIM_KNIGHT_IDLE_M;
            case HeroLook.HERO:
                switch (Knight.gender) {
                    case Gender.male:
                        return fw ? 'man_front_idle' : 'man_back_idle';
                    case Gender.female:
                    default:
                        return fw ? 'woman_front_idle' : 'woman_back_idle';
                }
            case HeroLook.ACOLYTE:
                return 'acolyte_front_idle';
        }
    }

    private static getKinghtWalk(fw: boolean): string {
        switch (Knight.heroLook) {
            case HeroLook.HORSE:
                switch (Knight.gender) {
                    case Gender.male:
                        return Keys.ANIM_KNIGHT_WALK_M;
                    case Gender.female:
                        return Keys.ANIM_KNIGHT_WALK_W;
                }
                return Keys.ANIM_KNIGHT_WALK_M;
            case HeroLook.HERO:
                switch (Knight.gender) {
                    case Gender.male:
                        return fw ? 'man_front_walk' : 'man_back_walk';
                    case Gender.female:
                    default:
                        return fw ? 'woman_front_walk' : 'woman_back_walk';
                }
            case HeroLook.ACOLYTE:
                return 'acolyte_front_walk';
        }
    }
}